module.exports = __webpack_public_path__ + "static/media/poligonIcon.acf45dfe.svg";